export const PrintingService = `${process.env.REACT_APP_PRINTING_GATEWAY}/PrintingService`;